<template>
    <CardedDisplay>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-television</v-icon> TITLE: </b> {{ advert.title }}
        </div>
      </div>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-dot</v-icon> Clicks: </b> {{ advert.advert_clicks.length }}
        </div>
      </div>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-box</v-icon> Dimensions: </b> 
          Width <b>{{ advert.width_pixels }}</b><i>pixels</i> X 
          Height <b>{{ advert.height_pixels }}</b><i>pixels</i>
        </div>
      </div>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-earth</v-icon> Navigation Click Url: </b>
          <a target="blank" :href="advert.navigation_url">{{
            advert.navigation_url
          }}</a>
        </div>
      </div>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-home-map-marker</v-icon> Site Placement: </b>
          Platform: <b>{{ advert.platform }}</b>, &nbsp;
          Page: <b>{{ advert.page }}</b>, &nbsp;
          Section: <b>{{ advert.section }}</b> 
        </div>
      </div>
      <div class="text-left mt-5">
        <div>
          <b><v-icon>mdi-eye</v-icon> Media Preview: </b>
        </div>
        <div>
          <v-img
            grey
            :src="advert.media_url"
            :min-width="advert.width"
            :min-height="advert.height"
          >
          </v-img>
        </div>
      </div>
    </CardedDisplay>
</template>

<script>
import Utils from '../lib/Utils';
import CardedDisplay from "./CardedDisplay";
export default {
    name: "AdvertView",
    components:{
        CardedDisplay
    },
    props:{
        advert: {
            type: Object,
            defaul: () => {
                return Utils.get_default_advert()
            }
        }
    }
}
</script>